var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":_vm.button.src,"alt":_vm.button.label}}),_c('h5',{domProps:{"innerHTML":_vm._s(_vm.$t('NAV_BUTTON_LABEL', { 'button.label': _vm.$t(("" + (_vm.button.label)))}))}})])}
var staticRenderFns = []

export { render, staticRenderFns }